import { cols } from "@/config/system";
import { momentFormat } from "@/utils/formatter";

export const tableColumn = [
  {
    type: "index",
    label: "序号",
    fixed: true,
    disabled: true,
  },
  {
    label: "运单号",
    prop: "billCode",
    width: cols.op3
  },
  {
    label: "售后类型",
    prop: "orderTypeName",
  },
  {
    label: "提交状态",
    prop: "status",
    width: cols.op1
  },
  {
    label: "失败原因",
    prop: "reason",
  },
];

export const tableColumn1 = [
  {
    type: "index",
    label: "序号",
    fixed: true,
    disabled: true,
  },
  {
    label: "电子面单账号",
    prop: "partnerId",
    width: cols.op3
  },
  {
    label: "商家名称",
    prop: "customerName",
  },
  {
    label: "状态",
    prop: "status",
    width: cols.op1
  },
  {
    label: "失败原因",
    prop: "reason",
  },
];
